import { useEffect } from 'react';

export function useTitle(title) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} | TrainForge` : 'TrainForge — AI-Powered Gym Platform';
    return () => { document.title = prev; };
  }, [title]);
}
